<!-- 产品解决方案／群星金融N+1供应链金融产品 -->
<template>
  <div id="join">
    <section>
      <div class="coverheader">
        <header>
          <div class="cover">
            <h1>加入群星</h1>
            <h2>在群星，各个领域的人才都能大有所为，我们珍视充满热情、勇气和敢于创新的人才。<br>我们的每一个团队、每一个角色都需要这样的员工。加入群星，让你成就非凡的职业生涯。</h2>
            <div class="team-type">
              <span @click="teamType = 'dev'" :class="teamType === 'dev' ? 'blue' : ''">研发团队</span>
              <span @click="teamType = 'ser'" :class="teamType === 'ser' ? 'blue' : ''">业务团队</span>
              <span @click="teamType = 'pro'" :class="teamType === 'pro' ? 'blue' : ''">产品团队</span>
            </div>
            <div class="team-detail" v-if="teamType === 'dev'">
              <img src="/imgs/portal/join/group_developer@2x.png" alt="img" class="left">
              <div class="right">
                <span class="team-name">研发团队</span>
                <span class="contant">我们的工程师在开发软件时，会时刻关注用户。<br>这也是群星平台及APP方便易用的原因。<br>未来，他们将依然保持对用户的尊重，并实现更多的创新突破。</span>
                <a href="https://www.lagou.com/jobs/4628516.html" target="_blank">JAVA高级研发工程师</a>
                <a href="https://www.lagou.com/jobs/5009464.html" target="_blank">自动化测试工程师</a>
                <a href="https://www.lagou.com/jobs/4309762.html" target="_blank" style="margin-right:0;">中级前端开发工程师</a>
              </div>
            </div>
            <div class="team-detail" v-else-if="teamType === 'ser'">
              <img src="/imgs/portal/join/group_yewu@2x.png" alt="img" class="left">
              <div class="right">
                <span class="team-name">业务团队</span>
                <span class="contant">帮助企业伙伴去思考如何借助供应链金融方案，<br>为他们的公司创造更多价值、实现更多可能，并让上下游获得共赢，<br>这是成为群星金融顾问的重要价值。</span>
                <a href="https://www.lagou.com/jobs/2507439.html" target="_blank">大客户代表</a>
                <a href="https://www.lagou.com/jobs/4301529.html" target="_blank">资金渠道经理</a>
                <a href="https://www.lagou.com/jobs/4032521.html" target="_blank">项目经理</a>
              </div>
            </div>
            <div class="team-detail" v-else-if="teamType === 'pro'">
              <img src="/imgs/portal/join/group_product@2x.png" alt="img" class="left">
              <div class="right">
                <span class="team-name">产品团队</span>
                <span class="contant">执行非同凡响的标准，<br>满足非比寻常的期待。</span>
                <a href="https://www.lagou.com/jobs/3916487.html" target="_blank">产品部门助理</a>
              </div>
            </div>
          </div>
        </header>
      </div>
      <footer>
        <div class="cover">
          <h1>招聘Q&A</h1>
          <div class="right">
            <span>我可以通过什么渠道申请岗位？</span>
          </div>
          <div class="left">
            <img src="/imgs/portal/join/qunxiaoxing@2x.png" alt="img">
            <span>您可以直接将简历附件发送至邮箱：zpsh@iqunxing.com<br>并备注您意向投递的岗位。若有岗位机会，会优先联系。</span>
          </div>
          <div class="right">
            <span>公司岗位的招聘流程是怎样的？</span>
          </div>
          <div class="left">
            <img src="/imgs/portal/join/qunxiaoxing@2x.png" alt="img">
            <span>简历经过筛选后，HR会沟通面试时间，初次面试通过后方可进行复试<br>部分岗位需要进行笔试。具体根据岗位要求而定。</span>
          </div>
          <div class="right">
            <span>公司对新员工有培训么？</span>
          </div>
          <div class="left">
            <img src="/imgs/portal/join/qunxiaoxing@2x.png" alt="img">
            <span>有，新员工入职一个月内进行新员工入职培训(具体时间以邮件为<br>准)，后期还会有其他培训，例如技能分享会等等。</span>
          </div>
        </div>
      </footer>
    </section>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import Footer from './HomeFooter'

export default {
  created () {
  },
  components: {
    'portal-footer': Footer
  },
  data () {
    return {
      teamType: 'dev'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";

#join{
  margin-top: 96px;
  background: rgba(45,45,45,0.98);
  .cover{
    width: 1000px;
    margin: 0 auto;
  }
  section{
    background-image: linear-gradient(-179deg, #21252F 0%, #040507 42%, #000000 99%);
    .coverheader{
      background: rgba(#000000, 0.5);
    }
    header{
      background: url(/imgs/portal/join/bg_join@2x.png) center top no-repeat;
      background-size: contain;
      height: 604px;
      h1{
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        line-height: 24px;
        font-weight: normal;
        border-bottom: 1px solid #41434B;
        padding: 24px 0 8px;
        margin: 0;
      }
      h2{
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0.43px;
        text-align: center;
        line-height: 28px;
        margin: 0 auto;
        padding: 50px 0 35px;
        font-weight: normal;
        width: 738px;
      }
      .team-type{
        width: 355px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        text-align: center;
        line-height: 14px;
        overflow: hidden;
        box-sizing: border-box;
        margin: 0 auto 30px;
        cursor: pointer;
        span{
          width: 116px;
          float: left;
          display: block;
          padding: 14px 0;
          border: 1px solid rgba(#fff, 0.5);
          &:nth-child(2){
            border-left: 0;
            border-right: 0; 
          }
        }
        span:first-child{
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          &.blue{
            border-right-color: rgba(#fff, 0.5);
          }
        }
        span:last-child{
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          &.blue{
            border-left-color: rgba(#fff, 0.5);
          }
        }
        .blue{
          background: #1F5DEA;
          border-color: #1F5DEA;
        }
      }
      .team-detail{
        width: 880px;
        height: 250px;
        opacity: 0.9;
        background: #FFFFFF;
        border-radius: 4px;
        margin: 0 auto;
        img{
          width: 240px;
          margin-right: 50px;
          vertical-align: top;
        }
        .right{
          display: inline-block;
          vertical-align: top;
          width: 520px;
          text-align: left;
          padding: 40px 0 46px;
          .team-name{
            font-family: PingFangSC-Medium;
            font-size: 21px;
            color: #222222;
            letter-spacing: 0.5px;
            display: block;
          }
          .contant{
            display: block;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #222222;
            letter-spacing: 0.38px;
            text-align: justify;
            margin: 15px 0 38px;
          }
          a{
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #0070C9;
            letter-spacing: 0.38px;
            text-align: justify;
            line-height: 16px;
            margin-right: 30px;
          }
        }
      }
    }
    footer{
      padding-bottom: 60px;
      .cover{
        width: 880px;
        margin: 0 auto;
      }
      h1{
        font-family: PingFangSC-Medium;
        font-size: 38px;
        color: #FFFFFF;
        letter-spacing: 1.19px;
        text-align: center;
        line-height: 38px;
        margin: -20px 0 40px;
      }
      span{
        display: inline-block;
        border-radius: 100px;
        padding: 22px 50px;
        background: rgba(#fff, 0.2);
      }
      .right{
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0.5px;
        text-align: right;
        line-height: 18px;
      }
      .left{
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #FFFFFF;
        letter-spacing: 0.43px;
        line-height: 28px;
        margin: 46px 0;
        img{
          width: 80px;
          vertical-align: top;
          margin: 10px 29px 0 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Join.vue?2f57a6da